import { render } from "./CheckoutWallet.vue?vue&type=template&id=12767295"
import script from "./CheckoutWallet.vue?vue&type=script&lang=js"
export * from "./CheckoutWallet.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__